import { expenseCalendarDate } from './expense_days';
const enabled = (value) => value === true || value === 1 || value === '1' || value === 'true';
const calendarDate = (value) => {
    const text = String(value !== null && value !== void 0 ? value : '').trim();
    const local = text.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    return expenseCalendarDate(local ? `${local[3]}-${local[2]}-${local[1]}` : text);
};
export function localTravelDate(now = new Date()) {
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}
export function travelCollapsePolicy(plan = {}, progress = {}, now = new Date()) {
    var _a, _b, _c, _d, _e, _f, _g;
    const day = localTravelDate(now);
    const start = calendarDate((_a = plan.date_start) !== null && _a !== void 0 ? _a : progress.start_date);
    const finish = calendarDate((_b = plan.date_finish) !== null && _b !== void 0 ? _b : plan.date_end);
    const status = (_d = (_c = plan.travel_status_id) !== null && _c !== void 0 ? _c : plan.status_id) !== null && _d !== void 0 ? _d : (typeof plan.travel_status === 'object'
        ? (_f = (_e = plan.travel_status) === null || _e === void 0 ? void 0 : _e.travel_status_id) !== null && _f !== void 0 ? _f : (_g = plan.travel_status) === null || _g === void 0 ? void 0 : _g.id : plan.travel_status);
    const finished = String(status) === '2' || enabled(progress.finished) || enabled(progress.completed)
        || enabled(plan.finished) || Boolean(progress.finished_at || progress.completed_at || plan.finished_at || plan.completed_at);
    const started = progress.started == null ? Boolean(progress.started_at || plan.started_at) : enabled(progress.started);
    const active = started && !finished && (!start || start <= day) && (!finish || finish >= day);
    return { day, active, scope: `${day}:${active ? 'active' : started || finished ? 'closed' : 'planned'}` };
}
export function isTravelCollapseDay(policy, startValue, finishValue) {
    if (!policy.active)
        return false;
    const start = calendarDate(startValue);
    const finish = calendarDate(finishValue) || start;
    return Boolean(start && finish && policy.day >= (start < finish ? start : finish) && policy.day <= (start > finish ? start : finish));
}
/** Files use the item's dates; the group's date is only a fallback. */
export function isCurrentTravelFileItem(policy, item) {
    const params = Array.isArray(item.params) ? item.params : [];
    const dateFor = (keys) => {
        var _a, _b, _c, _d, _e, _f;
        for (const key of keys) {
            const param = params.find(row => row.param_key === key);
            const value = calendarDate((_f = (_e = (_d = (_c = (_b = (_a = param === null || param === void 0 ? void 0 : param.value) !== null && _a !== void 0 ? _a : param === null || param === void 0 ? void 0 : param.param_value) !== null && _b !== void 0 ? _b : param === null || param === void 0 ? void 0 : param.field_value) !== null && _c !== void 0 ? _c : param === null || param === void 0 ? void 0 : param.value_text) !== null && _d !== void 0 ? _d : param === null || param === void 0 ? void 0 : param.value_str) !== null && _e !== void 0 ? _e : param === null || param === void 0 ? void 0 : param.value_date) !== null && _f !== void 0 ? _f : item[key]);
            if (value)
                return value;
        }
        return '';
    };
    const start = dateFor(['depart_date', 'start_date', 'date_start', 'checkin_date', 'visit_date', 'when_date', 'date']);
    const finish = dateFor(['arrive_date', 'end_date', 'date_finish', 'checkout_date', 'finish_date']);
    const group = item.travel_day && typeof item.travel_day === 'object' ? item.travel_day : {};
    return isTravelCollapseDay(policy, start || finish || item.travel_day_date || group.day_date, finish || start);
}
export function readTravelCollapseValues(raw, scope) {
    try {
        const saved = JSON.parse(raw || 'null');
        if ((saved === null || saved === void 0 ? void 0 : saved.scope) !== scope || !saved.values || typeof saved.values !== 'object' || Array.isArray(saved.values))
            return {};
        return Object.fromEntries(Object.entries(saved.values).filter(([, value]) => typeof value === 'boolean'));
    }
    catch {
        return {};
    }
}
/** Save explicit changes only: newly loaded days must still receive their defaults. */
export function updateTravelCollapseValues(overrides, defaults, update) {
    const previous = { ...defaults, ...overrides };
    const next = typeof update === 'function' ? update(previous) : update;
    const changed = Object.fromEntries(Object.entries(next).filter(([key, value]) => typeof value === 'boolean'
        && (value !== previous[key] || Object.prototype.hasOwnProperty.call(overrides, key))));
    return { ...overrides, ...changed };
}
